export default __webpack_public_path__ + "static/media/penguin.81a30dd8.png";